<template>
  <ion-content :class="`orders ${isDense ? 'dense' : ''}`">
    <!-- Client Name -->
    <ion-card-header :style="{ padding: '20px 8px' }">
      Cliente: {{ client.A1_NREDUZ || client.A1_NOME }}
    </ion-card-header>

    <!-- Loading -->
    <ion-grid v-if="!items" :style="{height: '25%'}">
      <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
        <ion-col size="12">
          <ion-label>Carregando itens</ion-label>
          <br/>
          <ion-spinner name="dots"></ion-spinner>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- No Data -->
    <ion-grid v-else-if="items && items.length == 0" :style="{height: '20%'}">
      <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
        <ion-col size="12">
          <ion-label>Sem registros.</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-card class="card-orders" v-for="(item, index) in items" :key="index" :style="{ margin: '5px 10px 5px 5px' }">
      <ion-card-header :style="{ padding: '8px' }" @click="item.show = !item.show">
        <ion-grid class="ion-no-padding">
          <ion-row class="row-margin-bottom">
            <ion-item class="ion-no-padding ion-no-margin" :style="{width: '100%', minHeight: '16px'}">
              <div
                class="ion-text-start"
                :style="{ fontSize: '0.7em', marginRight: '5px' }"
              >
                {{ computedHeadersMobile.filter(chm => chm.mobile.title).map(th => item[th.value]).join(' ') }}
              </div>
              <span v-for="(st, indexSt) in computedHeadersMobile.filter(chm => chm.mobile.subTitle)" :key="indexSt">
                {{ item[st.value] + ' ' }}
              </span>
              <ion-icon :size="isDense ? 'small': 'default'"  class="ion-no-padding ion-no-margin" slot="end" :icon="(item.show) ? chevronUp : chevronDown"></ion-icon>
            </ion-item>
          </ion-row>
          <template v-if="!item.show">
            <!-- <hr :style="{ height: '.25px', width: '100%' }" color="grey" /> -->
            <ion-row class="ion-justify-content-between">
              <div v-for="(header, index) of computedAllHeaders.filter(h => !h.mobile || (h.mobile && !h.mobile.hidden))" :key="index" 
                :class="'inherit'">
                <ion-row class="ion-justify-content-center">
                  <small>{{ header.text }}</small>
                </ion-row>
                <ion-row class="ion-justify-content-center">
                  {{ formartFields({header, value: item[header.value]}) }} 
                </ion-row>
              </div>
            </ion-row>
          </template>
        </ion-grid>
      </ion-card-header>

      <template v-if="item.show">
        <ion-card-content 
          class="ion-no-padding">
          <ion-list class="ion-no-padding ion-no-margin">
            <template v-for="(header, index) in computedAllHeaders.filter(h => !h.mobile || (h.mobile && !h.mobile.hidden))" :key="index">
              <ion-item>
                <ion-row class="ion-justify-content-center">
                  {{ header.text }}: {{ formartFields({header, value: item[header.value]}) }} 
                </ion-row>
              </ion-item>
            </template>
          </ion-list>
          <ion-row>
            <ion-col :style="{width: `${100/((computedCustomActions ? computedCustomActions.length : 0) + 1)}%`}">
              <ion-button style="width: 100%" @click="goTo({item})">
                <ion-icon class="ion-no-padding ion-no-margin" :icon="openOutline"></ion-icon> Abrir
              </ion-button>
            </ion-col>
            <ion-col v-for="({data: cAction}, idx) of computedCustomActions" :key="`customActionBtn-${idx}`">
              <ion-button 
                @click="clickAction({ item, customAction: cAction })">
                {{ cAction.name }}
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-card-content>
      </template>
    </ion-card>
  </ion-content>
</template>

<script>
import {
  IonCard,
  // IonContent,
  IonCardContent,
  IonCardHeader,
  IonList,
  IonItem,
  IonGrid,
  IonLabel,
  IonRow,
  IonCol,
  IonContent,
  IonSpinner,
  // IonLabel,
  IonButton,
  IonIcon
} from "@ionic/vue";
import {
  chevronDown, 
  chevronUp,
  openOutline
} from "ionicons/icons";
import store from "../store";
import {
  mapState,
} from "vuex";
export default {
  components: {
    // IonContent,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonList,
    IonItem,
    IonGrid,
    IonLabel,
    IonRow,
    IonCol,
    IonSpinner,
    IonContent,
    // IonLabel,
    IonButton,
    IonIcon
  },
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    color: {
      type: String,
      default: "teal"
    },
    dueDateField: String,
    client: Object,
    customActions: Array,
    props: Object,
  },
  emits: [
    "dueDateEvent"
  ],
  data() {
    return {
      hasDebit: false,
      expand: false,
      itemsDueDate: [],
      titleHeader: [],
      subTitleHeader: [],
    };
  },
  computed: {
    ...mapState(["companySelected"]),
    isDense() { return this.props.formDense },
    computedExpand(){
      return this.expand
    },
    computedHeadersMobile() {
      return this.headers.filter(header => header.mobile)
    },
    computedCustomActions() {
      return this.customActions
    },
    computedAllHeaders() {
      return this.headers.filter(header => header.mobile && !(header.mobile.title || header.mobile.subTitle))
    }
  },
  methods: {
    goTo({item}) {
      const url = `/tabs/SC5/detalhes/${(item.C5_NUMSITE.trim() !== '') ? item.C5_NUMSITE.trim() : this.companySelected.M0_CODIGO + this.companySelected.M0_CODFIL + item.C5_NUM}`
      store.$router.push(url);
    },
    showDetails(item) {
      item.show = !item.show;
    },
    isDueDate({item}) {
      let today = store.$moment(new Date(), 'YYYYMMDD')
      today = today.format('YYYYMMDD')
      return  (item && item[this.dueDateField] && today) ? today.trim() > item[this.dueDateField].trim() : false
    },
    formartFields({header, value}){
      let maskedValue = ``

      const prefix = header.prefix ? header.prefix + ' ' : ''

      // valor numérico
      if (header.type == 'float' || header.type == 'integer') {
        maskedValue =  value.toLocaleString('pt-br', { minimumFractionDigits: header.precisionText, maximumFractionDigits: header.precisionText })
      //data em formato string, geralmente como vem do Protheus (YYYYMMDD)
      } else if (header.date && !(value instanceof Date) && !isNaN(value) && typeof value === "string") {
        maskedValue = store.$moment(value, 'YYYYMMDD').format("DD/MM/YYYY");
      } else if (header.date && !(value instanceof Date) && !isNaN(value) && typeof value !== "string") {
        maskedValue = store.$moment(value.toDate()).format("DD/MM/YYYY");
      }
      else if (header.dateHour && !(value instanceof Date) && !isNaN(value) && typeof value !== "string") {
        maskedValue = store.$moment(value.toDate()).format("DD/MM/YYYY - HH:mm:ss");
      }
      else if (header.dateYear && !(value instanceof Date) && !isNaN(value) && typeof value !== "string") {
        maskedValue = store.$moment(value.toDate()).format("YYYY");
      }
      else if (header.datePlusWeek && !(value instanceof Date) && !isNaN(value) && typeof value !== "string") {
        maskedValue = store.$moment(value.toDate()).format("DD/MM/YYYY, dddd");
      } else {    
        maskedValue = value
      }

      const suffix = header.suffix
        ? ' ' + header.suffix
        : ''

      return prefix + maskedValue + suffix      
    }
  },
  setup() {
    return {
      chevronDown, 
      chevronUp,
      openOutline
    }
  },
  created() {
  }
  
};
</script>

<style scoped>
  .card-orders {
    margin: .1em;
  }
  ion-content.orders.dense {
    font-size: 0.7em;
  }
  ion-content.orders ion-list {
    background: transparent!important;
  }
  ion-content.orders ion-item::part(native) {
    background: transparent;
  }
  ion-content.orders.dense ion-item::part(native) {
    min-height: 0!important;
    font-size: 0.7em;
  }
</style>